module.exports = __webpack_public_path__ + "static/media/visual-story-icon1.c22ca727.svg";